import { useSuspenseQuery } from '@tanstack/react-query';

import { backendApiAuthenticationGetUserOptions } from '@/modules/api/backend/@tanstack/react-query.gen';

export function useUserSuspenseQuery() {
  return useSuspenseQuery(backendApiAuthenticationGetUserOptions());
}
